(function () {
  if (window.HCSQuickAdd) return;

  function sectionsToRender() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function rawAdd(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: id, quantity: qty, properties: { _qa_editable: '1' } }],
        sections: sectionsToRender(),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (state) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
      if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hcs-quick-add', cartData: state });
      }
      return state;
    });
  }

  window.HCSQuickAdd = function (variantId, btn, opts) {
    opts = opts || {};
    var id = parseInt(variantId, 10);
    var qty = opts.quantity || 1;
    if (!id) return Promise.reject(new Error('HCSQuickAdd: invalid variantId'));
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    var run;
    if (window.HCSCart && typeof window.HCSCart.add === 'function') {
      run = window.HCSCart.add(
        { items: [{ id: id, quantity: qty, properties: { _qa_editable: '1' } }] },
        { openDrawer: opts.openDrawer !== false }
      );
    } else {
      run = rawAdd(id, qty);
    }

    return run.then(function (state) { return state; }).finally(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    });
  };
})();
